import { Injectable } from "@angular/core";
import * as Log from "~/app/core/log";

export enum NetworkConnectionType {
    Wifi, Mobile, VPN, Ethernet, Bluetooth, None
}

@Injectable()
export class NetworkService {
    private static APPLICATION_JSON = "application/json";
    private static ERROR_NO_DATA = "Data not available";

    get connectionType(): NetworkConnectionType {
        return window.navigator.onLine ? NetworkConnectionType.Wifi : NetworkConnectionType.None;
    }

    private onlineListener;
    private offlineListener;

    constructor(
    ) {

    }

    watchConnectionType(connectionTypeChangedCallback: (newConnectionType: NetworkConnectionType) => void): void {
        this.onlineListener = () => {
            connectionTypeChangedCallback(NetworkConnectionType.Wifi);
        };

        this.offlineListener = () => {
            connectionTypeChangedCallback(NetworkConnectionType.None);
        };

        window.addEventListener('online', this.onlineListener);
        window.addEventListener('offline', this.offlineListener);
    }

    stopWatchingConnectionType() {
        window.removeEventListener('online', this.onlineListener);
        window.removeEventListener('offline', this.offlineListener);
        this.onlineListener = null;
        this.offlineListener = null;
    }
}
